module.exports = __webpack_public_path__ + "img/img3.838ed4df.jpg";